import { useEffect, useState } from 'react';
import { Table, Row, Card, Col, Button, } from 'antd';
import AssignmentService from '../services/AssignmentService';
import { formatDate } from '../utils';
import AssignmentDetail from '../components/Assignments/AssignmentDetail';
import {
  CloseCircleTwoTone,
  CheckCircleTwoTone,
  ClockCircleOutlined
} from '@ant-design/icons';
import { NavLink } from 'react-router-dom';

const Exams = () => {
  const [loading, setLoading] = useState(false);
  const [assignments, setAssignments] = useState<any[]>([]);

  const getExams = async () => {
    try {
      setLoading(true)
      const assignmentsResponse = await AssignmentService.getAllMe('');
      setAssignments(assignmentsResponse?.data ?? [])
      setLoading(false)

      // setLessons(assignmentData);
    } catch (error) {
      console.error(error);
      setLoading(false)

    }
  };

  useEffect(() => {
    getExams();
  }, []);

  const columns = [
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, record: any) => {
        const isExpired = !record.isDone && record.isExpired;
        return (
          <>
            {record.isDone ? (
              <Row align={'middle'}>
                <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 24, marginRight: 5 }} /> Tamamlandı
              </Row>
            ) : isExpired ? (
              <Row align={'middle'}>
                <CloseCircleTwoTone twoToneColor="#eb2f96" style={{ fontSize: 24, marginRight: 5 }} /> Süresi Doldu
              </Row>
            ) : record?.responseContent || record?.responseImage ? (
              <Row align={'middle'}>
                <CloseCircleTwoTone twoToneColor="#eb2f96" style={{ fontSize: 24, marginRight: 5 }} /> Eksik veya Hatalı
              </Row>
            ) : (
              <Row align={'middle'}>
                <ClockCircleOutlined style={{ fontSize: 24, marginRight: 5, color: "#FED449" }} /> Beklemede
              </Row>
            )}
          </>
        );
      }
    },
    {
      title: 'Ders',
      dataIndex: 'lessonName',
      key: 'lessonName',
    },
    {
      title: 'Ödev',
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: 'Teslim Tarihi',
      dataIndex: 'dueDate',
      render: (text: any) => (
        <>
          {formatDate(text)}
        </>
      )
    },
    {
      title: 'Ödev Tarihi',
      dataIndex: 'createdAt',
      render: (text: any) => (
        <>
          {formatDate(text)}
        </>
      )
    },
    {
      title: 'İşlem',
      key: 'action',
      render: (_: any, record: any) => (
        <>
          <AssignmentDetail item={record} getTrigger={getExams} />
        </>
      )
    },

  ];

  return (
    <>
      <Card bodyStyle={{ paddingTop: '0px' }} title="Ödevler"
        extra={<Row gutter={[16, 16]} justify={"space-between"} align={"middle"}>
          <Col>
            <NavLink to="/" >
              <Button size="large">
                Geri
              </Button>
            </NavLink>
          </Col>
        </Row>}>
        <Table loading={loading} dataSource={assignments} columns={columns} rowKey="id" />
      </Card>
    </>
  );
};

export default Exams;
